// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  chevron: "AdvancedControls__chevron",
  group: "AdvancedControls__group",
  groupBody: "AdvancedControls__groupBody",
  groupHead: "AdvancedControls__groupHead",
  groupTitle: "AdvancedControls__groupTitle",
  groupTitleWrap: "AdvancedControls__groupTitleWrap",
  groupToggle: "AdvancedControls__groupToggle",
  panel: "AdvancedControls__panel",
  reveal: "AdvancedControls__reveal",
  row: "AdvancedControls__row",
  rowHead: "AdvancedControls__rowHead",
  rowLabel: "AdvancedControls__rowLabel",
  rowValue: "AdvancedControls__rowValue",
  section: "AdvancedControls__section",
};
